import Button from "./button";
import { ArrowIcon } from "@cmsgov/ds-medicare-gov";
import { TermsAndConditions } from './TermsAndConditions';
import translate from '../functions/translate';
import { useState } from "react";

export const TermsAndConditionsToggle = () => {

    const [termsAndConditionsDisplayed, setTermsAndConditionsDisplayed] = useState(false);
    const toggleTermsAndConditions = () => setTermsAndConditionsDisplayed(current => !current);

    return <>
        <Button
            aria-label={translate(termsAndConditionsDisplayed ? 'collapse' : 'expand') + " " + translate('terms_and_conditions_capitalize')}
            variation={'ghost'}
            analyticsData={{
                text: translate('terms_and_conditions_capitalize'),
                parentComponentHeading: translate('create_an_account')
            }}
            onClick={toggleTermsAndConditions}
            style={{
                padding: 0
            }}
        >
            {translate('terms_and_conditions_capitalize')}
            <ArrowIcon
                direction={termsAndConditionsDisplayed ? 'up' : 'down'}
                className={'ds-u-padding-left--1'}
            />
        </Button>
        {termsAndConditionsDisplayed && <>
            <TermsAndConditions />
            <Button
                aria-label={translate('collapse') + " " + translate('terms_and_conditions_capitalize')}
                variation={'ghost'}
                onClick={toggleTermsAndConditions}
                style={{
                    fontSize: '1em',
                    padding: 0,
                }}
            >
                {translate('read_less')}{' - '}
            </Button>
        </>
        }
    </>;
};
